import { render, staticRenderFns } from "./ColumnGoodsEndDate.vue?vue&type=template&id=fe3b6206&scoped=true"
import script from "./ColumnGoodsEndDate.vue?vue&type=script&lang=ts"
export * from "./ColumnGoodsEndDate.vue?vue&type=script&lang=ts"
import style0 from "./ColumnGoodsEndDate.vue?vue&type=style&index=0&id=fe3b6206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3b6206",
  null
  
)

export default component.exports